export interface IPayment {
  is_usable: boolean;
  app_name: EPayment;
}

export interface IPaymentList {
  id: number | null;
  email: string;
  country: string;
  is_default: boolean;
  stripe_user_id: string;
  details_submitted: boolean;
  payouts_enabled: boolean;
}

export interface IStripeCurrency {
  id: number;
  code: string;
  type: EStripeCurrencyType;
  min_value: string;
}

export enum EStripeCurrencyType {
  REGULAR = 'regular',
  ZERO_DECIMAL = 'zero_decimal',
  THREE_DECIMAL = 'three_decimal',
}

export enum EPricingModel {
  FIXED = 'fixed',
  PER_ATTENDEE = 'per_attendee',
  HOURLY = 'hourly',
}

export enum EPayment {
  STRIPE = 'STRIPE',
}
